import { FooterButtons } from 'components';
import * as S from './style';

export function Footer() {
  return (
    <S.Footer>
      <FooterButtons />
    </S.Footer>
  );
}
